// Locatie en weer (0025-0026; docs/DESIGN.md §8.G, §8.WE), handgeschreven zoals family.ts en gelijk
// aan de API (apps/api/src/routes/v1/app/geo.ts, app/weather.ts). Coördinaten gaan alleen in
// bodies (nooit in een URL). openapi.contract.test.ts bewaakt dat elke aanroep bestaat.
const id = (value) => encodeURIComponent(value);
export function createWeatherClient(t) {
    const get = (path) => t.request('GET', path);
    const post = (path, body = {}) => t.request('POST', path, body);
    const patch = (path, body) => t.request('PATCH', path, body);
    const put = (path, body) => t.request('PUT', path, body);
    const del = (path, body) => t.request('DELETE', path, body);
    return {
        geo: () => get('/v1/app/geo'),
        geoSearch: (query, countryCode = 'NL') => post('/v1/app/geo/search', { query, country_code: countryCode }),
        geoChoose: (suggestionId, ifVersion) => put('/v1/app/geo', { suggestion_id: suggestionId, if_version: ifVersion }),
        geoClear: () => del('/v1/app/geo'),
        deviceGeo: (deviceId, mode, requestMeasurement, ifVersion) => patch(`/v1/app/devices/${id(deviceId)}/geo`, {
            mode,
            request_measurement: requestMeasurement,
            if_version: ifVersion,
        }),
        settings: () => get('/v1/app/weather/settings'),
        saveSettings: (input) => put('/v1/app/weather/settings', input),
        today: () => get('/v1/app/weather/today'),
    };
}
//# sourceMappingURL=weather.js.map